export const API_ROUTES = {
  GET_BANNER: "",
  BUDGET_MARATHON_TV: 'budget/GetMarathonStramDetails',
  GET_CATALOGUE: "home/getCatalogue"
};

export const AUTH_API_CONSTANTS = {
  LOGIN: "auth/login",
  LOGOUT: "auth/logout",
};
